import React from 'react';
import Seo from './Seo';
import LinkedInOptimizerPage from './LinkedInOptimizerPage';

// Standalone LinkedIn Studio — the optimizer tool on its own page, reached
// from the "Optimize my LinkedIn" CTA on the landing page.
//
// This used to wrap the tool in `.lol-studio` and render a second Header +
// ProductSidebar around it. That wrapper carried `h2,h3,h4 { color: #fff
// !important }` and forced input styling, which fought the tool's own theme
// and (with .App's inherited `text-align: center`) broke the LinkedIn
// preview. The optimizer now ships its own page shell in the same idiom as
// /auto-apply-session and /dashboard, so this route just mounts it.
const LinkedInStudioPage = () => (
  <>
    <Seo
      title="LinkedIn Studio — Optimize Your Profile"
      description="Paste your LinkedIn profile, target a role, and get AI-rewritten headline, About, and experience with a profile-strength score — clean and distraction-free."
      path="/linkedin-studio"
    />
    <LinkedInOptimizerPage />
  </>
);

export default LinkedInStudioPage;
